import axios from 'axios';

/**
 * 부서 목록을 DB에서 가져온다.
 * @returns {Promise<Array<{id: number, name: string}>>} 부서 목록 배열
 */
export const getDepartments = async () => {
  let result = [];

  try {
    const response = await axios.get(`${process.env.REACT_APP_YCMS_BACKEND_SERVER_URL}/departments`, {
      withCredentials: true,
    });
    result = response.data || [];
  } catch (e) {
    console.error('부서 데이터를 가져오는 중 오류 발생:', e.message);
  }

  return result;
};
